import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { BranchResponseEntity } from '../../domain/entities/BranchResponseEntity'

export const useBranchStore = defineStore('branchStore', () => {
  const data = ref<BranchResponseEntity>()

  function setBranches(newBranches: BranchResponseEntity) {
    data.value = newBranches 
  }

  return { data, setBranches }
})
